import { render, staticRenderFns } from "./StatementEditor.vue?vue&type=template&id=788bc99c&scoped=true"
import script from "./StatementEditor.vue?vue&type=script&lang=js"
export * from "./StatementEditor.vue?vue&type=script&lang=js"
import style0 from "./StatementEditor.vue?vue&type=style&index=0&id=788bc99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bc99c",
  null
  
)

export default component.exports